import React from 'react'
import Box from '@material-ui/core/Box'
import Tooltip from '@material-ui/core/Tooltip'
import { useFormikContext } from 'formik'
import each from 'lodash/each'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'

import { CardHeading } from '@components/layout/Card'
import { R } from '@utils/currency'
import { currentBudgetTotal, retirementBudgetTotal } from './totals'

export const Header = ({ isRetired, readOnly }) => {
  const { values: { detailed_budget, use_current_expense_for_retirement } } = useFormikContext()
  return (
    <CardHeading>
      <Box
        mr='1rem'
        display='flex'
        className='total-fields'
      >
        <Box flex='8' />
        <Box flex={use_current_expense_for_retirement ? '0' : '2'} />
        <Box flex='2' className='total-field'>
          <label>Total {isRetired ? 'Budget' : 'Current'}</label>
          <p>{R(currentBudgetTotal(detailed_budget)).format()}</p>
        </Box>
        <CopyValuesButton
          readOnly={readOnly}
        />
        <Box display={use_current_expense_for_retirement ? 'none' : 'block'} flex='2' className='total-field'>
          <label>Total Retirement</label>
          <p>{R(retirementBudgetTotal(detailed_budget)).format()}</p>
        </Box>
      </Box>
    </CardHeading>
  )
}

/* Button that copies all the values from the current budget to the
 * retirement budget.
 * To do this, iterate over all the available elements inside of the detailed_budget in
 * the values object and copy the first element of the array to the second element of the array.
 * Recall the shap of detailed_budget:
 *  {
 *    electric: ['10000'],
 *    internet: ['2000', '2000']
 *  }
 *  where the first element is current, and the second is retirement.
 */
const CopyValuesButton = ({ readOnly }) => {
  const { values, setFieldValue } = useFormikContext()
  const { use_current_expense_for_retirement, detailed_budget } = values
  const copyCurrentBudgetValuesToRetirementBudget = () => each(detailed_budget,
    (budgetValues, budgetKey) => setFieldValue(`detailed_budget.${budgetKey}[1]`, R(budgetValues[0]).value, false)
  )

  if (readOnly) {
    return (
      <FlexBoxWithoutCopyButton use_current_expense_for_retirement={use_current_expense_for_retirement} />
    )
  }

  return (
    <Box display={use_current_expense_for_retirement ? 'none' : 'flex'} justifyContent='center' alignItems='center' flex={use_current_expense_for_retirement ? '0' : '2'}>
      <Tooltip title='Copy all the expense values from your current expenses to retirement expenses. This will replace your retirement expense values.' placement='top'>
        <Box
          display='flex'
          alignItems='center'
          flexDirection='column'
          style={{ cursor: 'pointer' }}
          onClick={copyCurrentBudgetValuesToRetirementBudget}
        >
          <ArrowForwardIcon />
          <small>Copy</small>
        </Box>
      </Tooltip>
    </Box>
  )
}

const FlexBoxWithoutCopyButton = ({ use_current_expense_for_retirement }) =>
  <Box
    display={use_current_expense_for_retirement ? 'none' : 'flex'}
    flex={use_current_expense_for_retirement ? '0' : '2'}
  />
